import { render, staticRenderFns } from "./search-ADS.vue?vue&type=template&id=3226b530&scoped=true&"
import script from "./search-ADS.vue?vue&type=script&lang=js&"
export * from "./search-ADS.vue?vue&type=script&lang=js&"
import style0 from "./search-ADS.vue?vue&type=style&index=0&id=3226b530&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3226b530",
  null
  
)

export default component.exports